import templateUrl from './transportation-alternatives-page-template1.html';

export const transportationAlternativesPageTemplate1Component = {
	templateUrl,

	bindings: {
		details: '<',
		paginationDetails: '<',
		onPageChange: '&',
		onCountyChange: '&'
	},

	controller: class TransportationAlternativesPageTemplate1Component {
		constructor(ApiService, DateService) {
			'ngInject';

			this.apiService = ApiService;
			this.dateService = DateService;
		}

		_onPageChange(pageNumber) {
			return this.onPageChange({
				$event: pageNumber
			});
		}

		_getImage(report) {
			const image = report.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '/./images/placeholder.png';
		}

		_getTime(time) {
			return this.dateService.getFormattedTime(time);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/transportation-alternatives-page-template1/transportation-alternatives-page-template1.component.js